<template scrolling="no">
  <div class="typeform">
    <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template> -->

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Quick Tips
        </v-card-title>

        <v-card-text class="mt-6">
          <p>

          You can navigate to previous and next questions by clicking the arrows at the bottom right of the screen!
          </p>
          <p>

          There is also a progress bar indicating how far along you are at the bottom right of the screen.
          </p>
          <p>

          <!-- None of the questions are strictly required so feel free to skip ones you are uncomfortable answering. -->
          Most of the questions are required so that we are able to recommend the right resource.
          If you skip a question, you may be asked to return to it before submitting.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            OK, Thanks for the tip.
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
    <html>
      <head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <title>Social Isolation Assessment Survey</title>
      </head>
      <body role="application">
        <iframe
          id="typeform-full"
          width="100%"
          height="100%"
          frameborder="0"
          allow="camera; microphone; autoplay; encrypted-media;"
          :src="`https://form.typeform.com/to/${v2}`"
        ></iframe>
      </body>
    </html>
  </div>
</template>

<script>
export default {
  name: 'Assessment',
  data() {
    return {
      spanishFormID: 'b6BHBqA7',
      englishFormID: 'yPEghGWr',
      v2: 'rHzUQBXH', 
      dialog: true
    };
  },
};
</script>

<style scoped>
/* FULL PAGE TYPEFORM */
html {
  margin: 0;
  height: 100%;
  overflow: hidden;
}
iframe {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  border: 0;
}

.v-application--wrap {
  overflow: hidden;
}

.videoask-embed__button--1ONxk
  .videoask-embed__button_bottom--12Hzk
  .videoask-embed__button_right--tPZKf
  .videoask-embed__button_circle--3jJ6w
  .videoask-embed__size_extra_large--26w_3 {
  display: none;
}
</style>
